import { Grid, useMediaQuery, useTheme} from "@material-ui/core";
import React, {useState} from "react";
import Socials from "../components/Socials";
import MeniuFooter from "../components/MeniuFooter";
import StyledModal from "../components/StyledModal";

function Regulament(props: any = {}) {

    const theme = useTheme();
    const isMobile = useMediaQuery(theme.breakpoints.only('xs'));
    const [modal, setModal] = useState<any>({
        open: false,
        title: '',
        message: ''
    });

    return <Grid ref={props.forwardRef || null} container style={({textAlign: 'center'})}>
        <Grid item xs={12}>

            <br className={isMobile ? 'mobile_hide' : ''}/>
            <br className={isMobile ? 'mobile_hide' : ''}/><br className={isMobile ? 'mobile_hide' : ''}/>
            <br className={isMobile ? 'mobile_hide' : ''}/>
            <Socials/>

            <MeniuFooter/>
            <br/>
            <br/>
        </Grid>
        {modal.open ? <StyledModal open={modal.open}
                                   title={modal.title}
                                   message={modal.message} onClose={() => {
            setModal({
                open: false,
                title: '',
                message: ''
            })
        }}/> : null}
    </Grid>

}

export default Regulament;
